module.exports = __webpack_public_path__ + "img/background.eefe2299.png";